<template>
  <div class="vb-checkout-view">
    <b-container>

      <section class="section section--loader" v-if="loading">
        <loader size="large" :show_timing_slot="true" />
      </section>

      <section class="section" v-if="!loading">
        <b-row>
          <b-col md="12" xl="9">
            <checkout-content-block
              :selected_room="selected_room"
              :passengers="passengers"
              :quote="quote"
            />
          </b-col>
          <b-col md="12" xl="3">
            <sidebar
              :validate_on_mount="validate_on_mount"
              :integration="integration"
              :availability="get_availability()"
              :live_price="String(quote.live_price || 0)"
              :loading="loading"
              :purchasing="purchasing"
              :completed="completed"
              :discount_codes="discount_codes"
              @purchase="sidebar_data => { purchase(sidebar_data) }"
              @commit="event => { this.$store.commit(event.name, event.payload) }">

              <!--slot riepilogo ordine-->
              <template #resume>
                <!--placeholder per allinearlo al content-block-->
                <h2 class="vb-checkout__title">&nbsp;</h2>
              </template>

              <!--slot messaggi di stato-->
              <template #message>
                <!--acquisto completato-->
                <div v-if="completed" class="vb-sidebar__block">
                  <div v-if="success" v-html="'Acquisto completato con successo'" />
                  <div v-else v-html="'C\'è stato un problema.'" />
                </div>
                <!--acquisto in corso-->
                <div v-if="!completed && purchasing" class="text-center">
                  <loader>
                    <template>
                      <span>Prenotazione in corso... non abbandonare o ricaricare la pagina!</span>
                    </template>
                  </loader>
                </div>
              </template>
            </sidebar>
          </b-col>
        </b-row>
      </section>

    </b-container>
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import { alpitour_service_handler } from '@alpitour/services/common'
import { build_booking_data } from '@alpitour/utilities/book-normalize'
import { build_alpitour_passengers, build_sololand_passengers } from '@alpitour/utilities/passenger'
import CheckoutContentBlock from '@alpitour/components/views/content-blocks/checkout.vue'
import {custom_event, get_config} from "@src/utilities";

export default {
  name: 'checkout-view',
  components: {
    'checkout-content-block': CheckoutContentBlock,
  },
  computed: {
    ...mapState(['discount_codes']),
    ...mapState('liveat',['selected_room', 'passengers', 'quote']),
    ...mapGetters('liveat', ['is_only_stay_package']),
  },
  data() {
    return {
      integration: this.$config.integration,
      loading: false,                         // caricamento dati
      purchasing: false,                      // sidebar completatea -> acquisto in corso
      completed: false,                       // acquisto completato
      success: false,                         // esito della purchase() -> cambia il messaggio mostrato all'utente
      validate_on_mount: true,
    }
  },
  mounted() {
    this.loading = false
  },
  methods: {
    purchase(sidebar_data) {
      const raw_passengers = this.passengers.passengers
      const passengers = this.is_only_stay_package
        ? build_sololand_passengers(raw_passengers)
        : build_alpitour_passengers(raw_passengers)

      const book = {
        ...sidebar_data.guest.payload,
        bookingData: build_booking_data({
          is_only_stay: this.is_only_stay_package,
          quote: this.quote,
          paxs: passengers,
          payments: sidebar_data.payments,
          selected_room: this.selected_room,
        }),
      }

      if (sidebar_data.guest.payload.beneficiaryId) {
        book.beneficiaryId = sidebar_data.guest.payload.beneficiaryId
      }
      
      if (sidebar_data.bill_to_pax !== false) {
        book.guestAddress = sidebar_data.bill_to_pax.payload.guestAddress
        book.guestCity = sidebar_data.bill_to_pax.payload.guestCity
        book.guestPostalCode = sidebar_data.bill_to_pax.payload.guestPostalCode
        book.guestProvince = sidebar_data.bill_to_pax.payload.guestProvince
        book.guestFiscalCode = sidebar_data.bill_to_pax.payload.guestFiscalCode        
      }
            
      this.purchasing = true
      this.success = false

      window.scrollTo(0,0)
      alpitour_service_handler('book', book)
        .then(
          (success) => {
            const { data } = success
            const {
              boughtProductTypes = [],
              live_price,
              sololandVoucherId,
              holidayVoucherId,
              confirmcode: confirm_code,
            } = data

            this.success = true
            this.purchasing = false
            this.completed = true
            window.scrollTo(0,0) // la sidebar sparisce quasi per intero => riporto lo scroll della pagina in alto
  
            custom_event('confirmedCheckout', get_config('integration.company'), live_price, 'partnerBehaviour')
            
            boughtProductTypes.forEach(productType => {
              custom_event('book', productType, live_price, 'productType')
            })
            
            const raw_voucher_id = this.is_only_stay_package ? sololandVoucherId : holidayVoucherId
            if (!raw_voucher_id && raw_voucher_id !== 0) {
              this.log('[book] - missing voucher ID in response')
              this.success = false
              this.purchasing = false
              return
            }
            const holiday_voucher_id = String(raw_voucher_id)
            const resolved = this.$router.resolve({
              name: 'confirm',
              params: {
                holiday_voucher_id,
                confirm_code,
              }
            })
            window.location.href = resolved.href

          },
          (error) => {
            this.log('[book] - error')
            this.log(error.response)
            this.validate_on_mount = true
            this.success = false
            this.purchasing = false
            custom_event('failedCheckout', get_config('integration.company'), book.bookingData.live_price, 'partnerBehaviour')
          }
        )
    }
  }

}
</script>
